import React, { useLayoutEffect, useRef, useEffect } from 'react'
import gsap from 'gsap'
import Layout from './layout'

// https://stackblitz.com/edit/react-6rzfpp?file=src%2Frouter%2FRouter.js
// https://gsap.com/
// https://gsap.com/docs/v3/GSAP/Tween

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

const useGSAP = (callback: () => void, dependencies: readonly unknown[] = [], scope: Element | string | object) => {
  // if (typeof callback !== "function") {
  //     if (callback && ("current" in callback)) {
  //         scope = callback;
  //         callback = null;
  //     } else {
  //         console.warn("First parameter must be a function or scope Ref");
  //     }
  // }
  const context = gsap.context(() => {}, scope)
  // @ts-ignore
  const contextSafe = (func: string | object) => context.add(null, func)
  useIsomorphicLayoutEffect(() => {
    callback && context.add(callback, scope)
    return () => context.revert()
  }, dependencies)
  return { context, contextSafe }
}

export default function Boxes() {
  const container = useRef<HTMLElement | null>(null)
  const tl = useRef<typeof gsap>()

  const toggleTimeline = () => {
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    tl.current.reversed(!tl.current.reversed())
  }

  useGSAP(
    () => {
      const boxes = gsap.utils.toArray<gsap.TweenTarget>('.box')

      /* eslint-disable @typescript-eslint/no-unsafe-call */
      // @ts-ignore
      tl.current = gsap
        .timeline()
        .to(boxes[0], { x: 120, rotation: 360 })
        .to(boxes[1], { x: -120, rotation: -360 }, '<')
        .to(boxes[2], { y: -166 })
        .reverse()
      /* eslint-enable @typescript-eslint/no-unsafe-call */
    },
    [],
    container
  )

  return (
    <Layout>
      <section className="boxes-container" ref={container}>
        <h1>Use the button to toggle a Timeline</h1>
        <div>
          <button onClick={toggleTimeline}>Toggle Timeline</button>
        </div>
        <div className="box border-black-50 border-2 w-[100px] bg-amber-500">Box 1</div>
        <div className="box">Box 2</div>
        <div className="box">Box 3</div>
      </section>
    </Layout>
  )
}
